import React, { useEffect } from 'react';
import { BeforeAfter } from './components/BeforeAfter';
import { BonusSection } from './components/BonusSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { NumbersSection } from './components/NumbersSection';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { SolutionReveal } from './components/SolutionReveal';
import { SystemDifference } from './components/SystemDifference';
import { TimeSavings } from './components/TimeSavings';
import { UseCases } from './components/UseCases';
import { VolumesSection } from './components/VolumesSection';
const META_PIXEL_ID = '1049314170929647';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-ivory text-graphite selection:bg-aqua/25 selection:text-navy" data-id="element-0" data-mp="3ubrg6gs32a2e">
      <noscript data-id="element-1" data-mp="d3cu5nj4soeg">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="d45v27vesjoo" />
      </noscript>
      <main data-id="element-3" data-mp="3gj1r23h9cp12">
        <Hero data-id="element-4" data-mp="3bmbazg5gdtfn" />
        <PainPoints data-id="element-5" data-mp="3bmtgl3e09k08" />
        <SolutionReveal data-id="element-6" data-mp="3bnct24kvzg6v" />
        <VolumesSection data-id="element-7" data-mp="3bo4lj6j6sxsx" />
        <SystemDifference data-id="element-8" data-mp="3qb7hv9vrx0eo" />
        <BonusSection data-id="element-9" data-mp="3qbfvx53mubrg" />
        <NumbersSection data-id="element-10" data-mp="3qbzfeq8xl87l" />
        <BeforeAfter data-id="element-11" data-mp="3qdakqui0yo0t" />
        <UseCases data-id="element-12" data-mp="3lkhbbtbm2rie" />
        <PricingSection data-id="element-13" data-mp="3ljxyus4qcvbr" />
        <TimeSavings data-id="element-14" data-mp="3ljpk0up1rfxx" />
        <Guarantee data-id="element-15" data-mp="3lieeapc1jy46" />
        <FAQ data-id="element-16" data-mp="2xuwv3i6ue8ct" />
        <FinalCTA data-id="element-17" data-mp="2xumznf3138zq" />
      </main>
      <Footer data-id="element-18" data-mp="2xtlrbided0lp" />
    </div>;
}